import deepCopyArray from './deepCopyArray';
import objectOf from '../objectOf';
import type { TypeDeepCopyConfig } from './types';
import { shouldExcludeDeepCopyValue } from './utils';

// ----------------------------------------------------------------------------

function deepCopyObject<T extends Record<string, any>>(obj: T, config: TypeDeepCopyConfig = {}): T {
    const copy = {} as T;
    const exclude = config.exclude ? new Set(config.exclude) : undefined;

    for (const key of Object.keys(obj) as (keyof T)[]) {
        const value = obj[key];
        const type = objectOf(value);

        if (shouldExcludeDeepCopyValue(exclude, { key: String(key), type })) {
            continue;
        }

        if (type === 'Array') {
            copy[key] = deepCopyArray(value, config) as T[keyof T];
        } else if (type === 'Object') {
            copy[key] = deepCopyObject(value, config);
        } else {
            copy[key] = value;
        }
    }

    return copy;
}

// ----------------------------------------------------------------------------

export default deepCopyObject;
